import { render, staticRenderFns } from "./PrintRedactionSheet.vue?vue&type=template&id=3ce38928&scoped=true"
import script from "./PrintRedactionSheet.vue?vue&type=script&lang=ts"
export * from "./PrintRedactionSheet.vue?vue&type=script&lang=ts"
import style0 from "./index.scss?vue&type=style&index=0&id=3ce38928&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce38928",
  null
  
)

export default component.exports